import { TIPO_FLOAT2, TIPO_FLOAT_LIVRE, TIPO_MONEY, TIPO_NUMBER, TIPO_PORCENTAGEM, TIPO_PORCENTAGEM_LIVRE, TIPO_RADIOBUTTOM, TIPO_RESULTADO, CRESCIMENTO_TERMINACAO, BEZERRO, VACA, NAO_GESTANTE, GESTANTE, GESTANTE_LACTANTE, LACTANTE, ZEBUINO, CRUZADO_CORTE, CRUZADO_LEITE, CONFINAMENTO, PASTO, MACHO, MACHO_CASTRADO, FEMEA, MAX_GMD, MAX_PESO_BEZERRO, MAX_PESO_MACHO, MAX_PESO_FEMEA } from '@/utils/types.js'
import { parseString } from '@/utils/utils'
import { MULTIPARAS, PRIMIPARAS } from '../utils/types'

class Exigencias {
    fn = null

    __data = {
      'CMS': {
        'exigencia': ['Matéria Seca', 'Dry matter', 'Materia seca'],
        'id': 'MS',
        'codigo': ['MS', 'DM', 'MS'],
        'unidade': ['kg/dia', 'kg/day', 'kg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'fator': 0.01,
        'selecionado': true,
        'idealEditable': true,
        'minEditable': false,
        'maxEditable': false,
        'disabled': true
      },
      'EE': {
        'exigencia': ['Extrato Etéreo', 'Ether extract', 'Extrato Etéreo'],
        'id': 'EE',
        'codigo': ['EE', 'EE', 'EE'],
        'unidade': ['kg/dia', 'kg/day', 'kg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'maxEditable': false,
        'fator': 0.01,
        'selecionado': false,
        'minEditable': false
      },
      'CNF': {
        'exigencia': ['Carboidratos Não Fibrosos', 'Non-fiber carbohydrates', 'Carbohidratos sin fibra'],
        'id': 'CNF',
        'codigo': ['CNF', 'NFC', 'CSF'],
        'unidade': ['kg/dia', 'kg/day', 'kg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'fator': 0.01,
        'selecionado': false,
        'idealEditable': true,
        'minEditable': false,
        'maxEditable': false
      },
      'FDN': {
        'exigencia': ['Fibra em Detergente Neutro', 'Neutral detergent fiber', 'Fibra detergente neutra'],
        'id': 'FDN',
        'codigo': ['FDN', 'NDF', 'FDN'],
        'unidade': ['kg/dia', 'kg/day', 'kg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'fator': 0.01,
        'selecionado': false,
        'idealEditable': true,
        'minEditable': false,
        'maxEditable': false,
        'divider': true
      },
      'NDT': {
        'exigencia': ['Exigências Totais de NDT', 'Total TDN requirements', 'Exigencias Totales de NDT'],
        'id': 'NDT_BRCORTE2016',
        'codigo': ['NDT', 'TDN', 'NDT'],
        'unidade': ['kg/dia', 'kg/day', 'kg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'fator': 0.01,
        'selecionado': false,
        'idealEditable': true,
        'minEditable': false,
        'maxEditable': false,
        'radio': true,
        'otherOptions': ['EL', 'EM'],
        'childs': {
          'PCJ': {
            'codigo': ['PCJ', 'SBW', 'APV'],
            'name': ['Peso Vivo em Jejum', 'Shrunk body weight', 'Ayuno de peso vivo'],
            'unidade': ['kg', 'kg', 'kg'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'PCVZ': {
            'codigo': ['PCVZ', 'EBW', 'PCVZ'],
            'name': ['Peso de Corpo Vazio', 'Empty body weight', 'Peso del cuerpo vacío'],
            'unidade': ['kg', 'kg', 'kg'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'GPCVZ': {
            'codigo': ['GPCVZ', 'EBWG', 'APCVZ'],
            'name': ['Ganho de Peso de Corpo Vazio', 'Empty body weight gain', 'Aumento de peso del cuerpo vacío'],
            'unidade': ['kg/dia', 'kg/day', 'kg/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'PCVZeq': {
            'codigo': ['PCVZeq', 'EQEBW', 'PCVZeq'],
            'name': ['Peso de Corpo Vazio equivalente', 'Equivalent empty body weight', 'Peso corporal vacío equivalente'],
            'unidade': ['kg', 'kg', 'kg'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          }
        }
      },
      'EL': {
        'exigencia': ['Energia Líquida', 'Net energy requirements', 'Energía Neta'],
        'id': 'EL',
        'codigo': ['EL', 'NE', 'EN'],
        'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 1,
        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'radio': true,
        'otherOptions': ['NDT', 'EM'],
        'childs': {
          'ELm': {
            'codigo': ['ELm', 'NEm', 'ENm'],
            'name': ['Energia Líquida (Mantença)', 'Net energy requirements for maintenance', 'Energía Neta (Mantenimiento)'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'ELg': {
            'codigo': ['ELg', 'NEg', 'ENg'],
            'name': ['Energia Líquida (Ganho)', 'Net energy requirements for gain', 'Energía Neta (Ganancia)'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'ELl': {
            'codigo': ['ELl', 'ELl', 'ENl'],
            'name': ['Energia Líquida (Lactação)', 'Net energy requirements for lactation', 'Energía Neta (Lactancia)'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          },
          'ERP': {
            'codigo': ['ERP', 'REp', 'ERP'],
            'name': ['Energia Retida como Proteína', 'Net energy retained in the form of protein', 'Energía retenida como proteína'],
            'unidade': ['%', '%', '%'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'km': {
            'codigo': ['km', 'km', 'km'],
            'name': ['Eficiência de Utilização de Energia Metabolizável para Mantença', 'Metabolizable energy efficiency for maintenance', 'Eficiencia de Uso de Energía Metabolizable para Mantenimiento'],
            'unidade': ['%', '%', '%'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'kg': {
            'codigo': ['kg', 'kg', 'kg'],
            'name': ['Eficiência de Utilização de Energia Metabolizável para Ganho', 'Metabolizable energy efficiency for weight gain', 'Eficiencia del uso de energía metabolizable para ganancia'],
            'unidade': ['%', '%', '%'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'PL': {
            'codigo': ['PL', 'NP', 'PL'],
            'name': ['Produção de Leite', 'Milk yield', 'Producción de leche'],
            'unidade': ['kg/dia', 'kg/day', 'kg/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          },
          'PLCG': {
            'codigo': ['PLCG', 'FCM', 'PLCG'],
            'name': ['Produção de Leite (corrigida para gordura)', '4 percent fat corrected milk', 'Leche con 4 por ciento de grasa corregida'],
            'unidade': ['kg/dia', 'kg/day', 'kg/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          }
        }
      },
      'EM': {
        'exigencia': ['Energia Metabolizável', 'Metabolizable energy requirements', 'Energía Metabolizable'],
        'id': 'EM_BRCORTE2016',
        'codigo': ['EM', 'ME', 'EM'],
        'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'divider': true,
        'radio': true,
        'otherOptions': ['EL', 'NDT'],
        'childs': {
          'EMm': {
            'codigo': ['EMm', 'MEm', 'EMm'],
            'name': ['Energia Metabolizável (Mantença)', 'Metabolizable energy requirements for maintenance', 'Energía Metabolizable (Mantenimiento)'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'EMg': {
            'codigo': ['EMg', 'MEg', 'EMg'],
            'name': ['Energia Metabolizável (Ganho)', 'Metabolizable energy requirements for gain', 'Energía Metabolizable (Ganancia)'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'EMl': {
            'codigo': ['EMl', 'MEl', 'EMl'],
            'name': ['Energia Metabolizável (Lactação)', 'Metabolizable energy requirements for lactation', 'Energía Metabolizable (Lactancia)'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          },
          'ED': {
            'codigo': ['ED', 'DE', 'ED'],
            'name': ['Energia Digestível', 'Digestible energy requirements', 'Energía digerible'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          }

        }
      },
      'PDR': {
        'exigencia': ['Proteína Degradada no Rúmen', 'Rumen degradable protein requirements', 'Proteína degradada en el rumen'],
        'id': 'PDR',
        'codigo': ['PDR', 'RDP', 'PDR'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'maxEditable': false,
        'minEditable': false
      },
      'PNDR': {
        'exigencia': ['Proteína Não Degradada no Rúmen', 'Rumen undegradable protein requirements', 'Proteína no degradada en el rumen'],
        'id': 'PNDR',
        'codigo': ['PNDR', 'RUP', 'PNDR'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'maxEditable': false,
        'minEditable': false
      },
      'PB': {
        'exigencia': ['Proteína Bruta', 'Crude protein requirements', 'Proteína cruda'],
        'id': 'PB',
        'codigo': ['PB', 'CP', 'PC'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'radio': true,
        'otherOptions': ['PM'],
        'childs': {
          'PL': {
            'codigo': ['PL', 'NP', 'PN'],
            'name': ['Proteína Líquida', 'Net protein requirements', 'Proteína Neta'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'PLg': {
            'codigo': ['PLg', 'NPg', 'PNg'],
            'name': ['Proteína Líquida (Ganho)', 'Net protein requirements (Gain)', 'Proteína neta (ganancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'k': {
            'codigo': ['EPM', 'EPM', 'EPM'],
            'name': ['Eficiência de Utilização de Proteína Metabolizável para Ganho', 'Metabolizable protein efficiency for weight gain', 'Eficiencia de la proteína metabolizable para el aumento de peso'],
            'unidade': ['%', '%', '%'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          }

        }
      },
      'PM': {
        'exigencia': ['Proteína Metabolizável', 'Metabolizable protein requirements', 'Proteína metabolizable'],
        'id': 'PM',
        'codigo': ['PM', 'MPt', 'PM'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'divider': true,
        'radio': true,
        'otherOptions': ['PB'],
        'childs': {
          'PMm': {
            'codigo': ['PMm', 'MPm', 'PMm'],
            'name': ['Proteína Metabolizável (Mantença)', 'Metabolizable protein requirements for maintenance', 'Proteína Metabolizable (Mantenimiento)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'PMg': {
            'codigo': ['PMg', 'MPg', 'PMg'],
            'name': ['Proteína Metabolizável (Ganho)', 'Metabolizable protein requirements for weight gain', 'Proteína Metabolizable (Ganancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'PMl': {
            'codigo': ['PMl', 'lCa', 'PMl'],
            'name': ['Proteína Metabolizável (Lactação)', 'Metabolizable protein requirements for lactation', 'Proteína Metabolizable (Lactancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          },
          'PBmic': {
            'codigo': ['PBmic', 'MCP', 'PBmic'],
            'name': ['Produção de Proteína Bruta Microbiana', 'Microbial crude protein synthesis', 'Producción de proteína cruda microbiana'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          }
        }

      },
      'Ca': {
        'exigencia': ['Exigências dietéticas de Cálcio', 'Dietary requirements of calcium', 'Requerimientos dietéticos de calcio'],
        'id': 'CA',
        'codigo': ['Ca', 'tCa', 'Ca'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': false,
        'childs': {
          'Cam': {
            'codigo': ['Cam', 'mCa', 'Cam'],
            'name': ['Exigências dietéticas de Cálcio (Mantença)', 'Dietary requirements of calcium for maintenance', 'Requerimientos dietéticos de calcio (mantenimiento)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Cag': {
            'codigo': ['Cag', 'gCa', 'Cag'],
            'name': ['Exigências dietéticas de Cálcio (Ganho)', 'Dietary requirements of calcium for weight gain', 'Requerimientos dietéticos de calcio (ganancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Cal': {
            'codigo': ['Cal', 'lCa', 'Cal'],
            'name': ['Exigências dietéticas de Cálcio (Lactação)', 'Dietary requirements of calcium for lactation', 'Requerimientos dietéticos de calcio (lactancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          }
        }
      },
      'P': {
        'exigencia': ['Exigências dietéticas de Fósforo', 'Total dietary requirements of phosphorus', 'Requerimientos dietéticos de fósforo'],
        'id': 'P',
        'codigo': ['P', 'tP', 'P'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': false,
        'childs': {
          'Pm': {
            'codigo': ['Pm', 'mP', 'Pm'],
            'name': ['Exigências dietéticas de Fósforo (Mantença)', 'Dietary requirements of phosphorus for maintenance', 'Requerimientos dietéticos de fósforo (mantenimiento)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Pg': {
            'codigo': ['Pg', 'gP', 'Pg'],
            'name': ['Exigências dietéticas de Fósforo (Ganho)', 'Dietary requirements of phosphorus for weight gain', 'Requerimientos dietéticos de fósforo (ganancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Pl': {
            'codigo': ['Pl', 'lP', 'Pl'],
            'name': ['Exigências dietéticas de Fósforo (Lactação)', 'Dietary requirements of phosphorus for lactation', 'Requerimientos dietéticos de fósforo (lactancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          }
        }
      },
      'Mg': {
        'exigencia': ['Exigências dietéticas de Magnésio', 'Dietary requirements of magnesium', 'Requerimientos dietéticos de magnesio'],
        'id': 'MG',
        'codigo': ['Mg', 'tMg', 'Mg'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': false,
        'childs': {
          'Mgm': {
            'codigo': ['Mgm', 'mMg', 'Mgm'],
            'name': ['Exigências dietéticas de Magnésio (Mantença)', 'Dietary requirements of magnesium for maintenance', 'Requisitos dietéticos para el magnesio (mantenimiento)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Mgg': {
            'codigo': ['Mgg', 'gMg', 'Mgg'],
            'name': ['Exigências dietéticas de Magnésio (Ganho)', 'Dietary requirements of magnesium for weight gain', 'Requerimientos dietéticos de magnesio (ganancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Mgl': {
            'codigo': ['Mgl', 'lMg', 'Mgl'],
            'name': ['Exigências dietéticas de Magnésio (Lactação)', 'Dietary requirements of magnesium for lactation', 'Requerimientos dietéticos de magnesio (lactancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          }
        }
      },
      'K': {
        'exigencia': ['Exigências dietéticas de Potássio', 'Dietary requirements of potassium', 'Requerimientos dietéticos de potasio'],
        'id': 'K',
        'codigo': ['K', 'K', 'K'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': false,
        'childs': {
          'KM': {
            'codigo': ['KM', 'mK', 'KM'],
            'name': ['Exigências dietéticas de Potássio (Mantença)', 'Dietary requirements of potassium for maintenance', 'Requerimientos dietéticos de potasio (mantenimiento)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Kg': {
            'codigo': ['Kg', 'gK', 'Kg'],
            'name': ['Exigências dietéticas de Potássio (Ganho)', 'Dietary requirements of potassium for weight gain', 'Requerimientos dietéticos de potasio (ganancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Kl': {
            'codigo': ['Kl', 'lK', 'Kl'],
            'name': ['Exigências dietéticas de Potássio (Lactação)', 'Dietary requirements of potassium for lactation', 'Requerimientos dietéticos de potasio (lactancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          }
        }
      },
      'Na': {
        'exigencia': ['Exigências dietéticas de Sódio', 'Dietary requirements of sodium', 'Requerimientos dietéticos de sodio'],
        'id': 'NA',
        'codigo': ['Na', 'Na', 'Na'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': false,
        'childs': {
          'Nam': {
            'codigo': ['Nam', 'mNa', 'Nam'],
            'name': ['Exigências dietéticas de Sódio (Mantença)', 'Dietary requirements of sodium for maintenance', 'Requisitos dietéticos de sodio (mantenimiento)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Nag': {
            'codigo': ['Nag', 'gNa', 'Nag'],
            'name': ['Exigências dietéticas de Sódio (Ganho)', 'Dietary requirements of sodium for weight gain', 'Requerimientos dietéticos de sodio (ganancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Nal': {
            'codigo': ['Nal', 'lNa', 'Nal'],
            'name': ['Exigências dietéticas de Sódio (Lactação)', 'Dietary requirements of sodium for lactation', 'Requerimientos dietéticos de sodio (lactancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          }
        }

      },
      'S': {
        'exigencia': ['Exigências dietéticas de Enxofre', 'Dietary requirements of sulfur', 'Requerimientos dietéticos de azufre'],
        'id': 'S',
        'codigo': ['S', 'S', 'S'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': false
      },
      'Co': {
        'exigencia': ['Exigências dietéticas de Cobalto', 'Dietary requirements of cobalt', 'Requerimientos dietéticos del cobalto'],
        'id': 'CO',
        'codigo': ['Co', 'Co', 'Co'],
        'unidade': ['mg/dia', 'mg/day', 'mg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': true
      },
      'Cu': {
        'exigencia': ['Exigências dietéticas de Cobre', 'Dietary requirements of copper', 'Requerimientos dietéticos de cobre'],
        'id': 'CU',
        'codigo': ['Cu', 'Cu', 'Cu'],
        'unidade': ['mg/dia', 'mg/day', 'mg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': true
      },
      'I': {
        'exigencia': ['Exigências dietéticas de Iodo', 'Dietary requirements of iodine', 'Requerimientos dietéticos de yodo'],
        'id': 'I',
        'codigo': ['I', 'I', 'I'],
        'unidade': ['mg/dia', 'mg/day', 'mg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': true
      },
      'Mn': {
        'exigencia': ['Exigências dietéticas de Manganês', 'Dietary requirements of manganese', 'Requerimientos dietéticos de manganeso'],
        'id': 'MN',
        'codigo': ['Mn', 'Mn', 'Mn'],
        'unidade': ['mg/dia', 'mg/day', 'mg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': true
      },
      'Se': {
        'exigencia': ['Exigências dietéticas de Selênio', 'Dietary requirements of selenium', 'Requerimientos dietéticos del selenio'],
        'id': 'SE',
        'codigo': ['Se', 'Se', 'Se'],
        'unidade': ['mg/dia', 'mg/day', 'mg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': true
      },
      'Zn': {
        'exigencia': ['Exigências dietéticas de Zinco', 'Dietary requirements of zinc', 'Requerimientos dietéticos de zinc'],
        'id': 'ZN',
        'codigo': ['Zn', 'Zn', 'Zn'],
        'unidade': ['mg/dia', 'mg/day', 'mg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': true
      }
    }
    animal = null
    state = null
    useFormat = true
    constructor (state, props, animal) {
      this.animal = animal
      var self = this
      this.state = state
      self.idioma = state.app.idioma
      self.strings = state.app.strings
      self.parseString = parseString
      self.TIPO_FLOAT2 = TIPO_FLOAT2
      self.TIPO_FLOAT_LIVRE = TIPO_FLOAT_LIVRE
      self.TIPO_NUMBER = TIPO_NUMBER
      self.TIPO_RESULTADO = TIPO_RESULTADO
      self.TIPO_RADIOBUTTOM = TIPO_RADIOBUTTOM

      for (let item in this.__data) {
        self.__data[item]['changed'] = (props && props[item] && props[item]['changed']) ? props[item]['changed'] : false
        self.__data[item]['minimo_calc'] = self.__data[item]['maximo_calc'] = self.__data[item]['ideal_calc'] = null
        self.__data[item]['minimo_raw'] = self.__data[item]['maximo_raw'] = self.__data[item]['ideal_raw'] = null;

        (function (fieldName) {
          Object.defineProperty(self, fieldName, {
            get: function () {
              if (!this.useFormat) return this.__data[fieldName]
              let casas = 2
              let newValue = Object.assign({}, self.__data[fieldName])
              for (let att of ['minimo', 'maximo', 'ideal']) {
                newValue[att] = (newValue[att] === null) ? 0 : newValue[att]
                newValue[att] = (newValue[att] === null || newValue[att] === '') ? '-' : newValue[att].toFixed(casas).replace('.', self.strings[self.idioma].separador_float)
                newValue[att + '_raw'] = self.__data[fieldName][att]
                if (newValue['childs']) {
                  for (let ex in newValue['childs']) {
                    if (typeof self.__data[fieldName]['childs'][ex][att] === 'string') newValue['childs'][ex][att] = parseFloat(newValue['childs'][ex][att])
                    newValue['childs'][ex][att] = (newValue['childs'][ex][att] === null) ? 0 : newValue['childs'][ex][att]
                    newValue['childs'][ex][att] = (newValue['childs'][ex][att] === null || newValue['childs'][ex][att] === '') ? '-' : newValue['childs'][ex][att].toFixed(casas).replace('.', self.strings[self.idioma].separador_float)
                  }
                }
              }
              return newValue
            },
            set: function (newValue) {
              for (let att of ['minimo', 'maximo', 'ideal']) {
                newValue[att] = (newValue[att] === '-') ? null : typeof newValue[att] === 'string' ? parseString(newValue[att], self.idioma) : newValue[att]
                if (newValue['childs']) {
                  for (let ex in newValue['childs']) {
                    newValue['childs'][ex][att] = (newValue['childs'][ex][att] === null || newValue['childs'][ex][att] === '-') ? 0 : typeof newValue['childs'][ex][att] === 'string' ? parseString(newValue['childs'][ex][att], self.idioma) : newValue['childs'][ex][att]
                  }
                }
              }
              self.__data[fieldName] = newValue
              self.__data['modified'] = (new Date()).getTime()
            }
          })
        })(item)
        if (props && props[item]) this[item] = props[item]
      }
    }

    getPV () {
      this.PV = (this.animal.peso_corporal_inicial) ? ((this.animal.peso_corporal_final + this.animal.peso_corporal_inicial) / 2) : this.animal.peso_corporal_medio
      return this.PV
    }

    calcCMS () {
      var CMSmax = 0.05
      var CMSmin = 1
      var CMS = 0
      const animal = this.animal
      this.animal.useFormat = false
      let PV = this.getPV()
      let TG = animal.dias_gestacao
      let SL = animal.semana_lactacao
      let PLe = animal.producao_de_leite
      let GMD = animal.ganho_medio_diario
      if (animal.tipo === VACA || animal.tipo === BEZERRO) {
        if (SL === undefined || SL === null || SL <= 0) {
          SL = 1
        }
        if (PLe === undefined || PLe === null || isNaN(PLe) || PLe <= 0) {
          let result = 8.819 - 0.069 * SL - 8.819 * Math.exp(-3.211 * SL)
          switch (animal.estado_parides) {
            case PRIMIPARAS:
              result = (
                6.431 -
                0.072 * SL -
                6.431 * Math.exp(-2.188 * SL)
              ).toFixed(2);
            break;
            case MULTIPARAS:
              result = (
                7.996 -
                0.101 * SL -
                7.996 * Math.exp(-1.447 * SL)
              ).toFixed(2);
          }
          PLe = result
          animal.producao_de_leite = PLe
          // animal.producao_de_leite_estimada = PLe
        }
      }

      // Zebuíno //Confinamento //Macho não Castrado
      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        CMSmax = 0.05 * 2
        if (animal.raca === ZEBUINO) {
          CMS = -2.1948 + (0.08338 * Math.pow(PV, 0.75)) + (3.9328 * GMD) - (0.9030 * GMD * GMD)
        } else if (animal.raca === CRUZADO_CORTE) {
          CMS = -0.6273 + (0.06453 * Math.pow(PV, 0.75)) + (3.871 * GMD) - (0.614 * GMD * GMD)
        } else if (animal.raca === CRUZADO_LEITE) {
          CMS = -2.8836 + (0.08435 * Math.pow(PV, 0.75)) + (4.5145 * GMD) - (0.9631 * GMD * GMD)
        }
      } else if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        if (animal.estado_fisiologico === NAO_GESTANTE) {
          CMSmax = 0.05 * 5
          CMS = 0.02 * PV
        } else if (animal.estado_fisiologico === LACTANTE || animal.estado_fisiologico === GESTANTE_LACTANTE) {
          CMS = (6.535 - 7.558 * Math.exp(-0.578 * SL) + 0.323 * SL + 1.66 * PLe) * (PV / 1000)
        } else if (animal.estado_fisiologico === GESTANTE) {
          CMS = 0.02 * PV - (0.8084 * Math.pow(PV, 1.0303) * 0.00002 * (TG - 135))
        }
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        // PLe = 8.819 - 0.069 * SL - 8.819 * Math.exp(-3.211 * SL)
        CMS = (0.353 - 0.532 * (0.1392 * PLe) + 0.01065 * PV + 0.3497 * GMD)
      }

      this.CMS.minimo = (CMS * (1 - CMSmin))
      this.CMS.ideal = (CMS)
      this.CMS.maximo = (CMS * (1 + CMSmax))
      return this.CMS
    }
    // ENERGIAS
    calcEE () {
      var fatorEEmax = 0.07
      if (this.animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        fatorEEmax = 0.40
      }
      var EEmax = this.CMS.ideal * fatorEEmax
      this.EE.maximo = EEmax
    }

    calcCNF () {
      var CNFmax = this.CMS.ideal * 0.8
      this.CNF.maximo = CNFmax
    }

    calcFDN () {
      var fatorFDNmin = 0.25
      var fatorFDNmax = 0.0132
      var FDNmin = this.CMS.ideal * fatorFDNmin
      var FDNmax = this.PV * fatorFDNmax
      this.FDN.minimo = FDNmin
      this.FDN.maximo = FDNmax
    }

    calcPCJ () {
      const animal = this.animal
      let PV = this.PV
      var PCJ = 0
      var PCJmin = 0
      var PCJmax = 0
      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        if (animal.raca === CRUZADO_CORTE || animal.raca === ZEBUINO) {
          PCJ = 0.8915 * Math.pow(PV, 1.0151)
        } else if (animal.raca === CRUZADO_LEITE) {
          PCJ = 0.9247 * Math.pow(PV, 1.0085)
        }
      } else if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        if (animal.estado_fisiologico === LACTANTE || animal.estado_fisiologico === GESTANTE_LACTANTE) {
          PCJ = 0.8915 * Math.pow(PV, 1.0151)
        } else {
          PCJ = 0.8084 * Math.pow(PV, 1.0303)
        }
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        PCJ = PV
      }
      this.NDT.childs.PCJ.minimo = PCJmin
      this.NDT.childs.PCJ.ideal = PCJ
      this.NDT.childs.PCJ.maximo = PCJmax
    }

    calcPCVZ () {
      const animal = this.animal
      var PCJ = this.NDT.childs.PCJ.ideal
      var PCVZ = 0
      var PCVZmin = 0
      var PCVZmax = 0
      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        if (animal.sexo === FEMEA) {
          // ---------FEMEA---------
          if (animal.raca === ZEBUINO) {
            PCVZ = 0.6110 * Math.pow(PCJ, 1.0667)
          } else if (animal.raca === CRUZADO_CORTE || animal.raca === CRUZADO_LEITE) {
            PCVZ = 0.6314 * Math.pow(PCJ, 1.0602)
          }
        } else {
          // ---------MACHO---------
          if (animal.regime === PASTO) {
            // Zebuino/Cruzado Inteiro/Castrado no Pasto
            PCVZ = 0.8507 * Math.pow(PCJ, 1.0002)
          } else {
            if (animal.raca === ZEBUINO) {
              if (animal.sexo === MACHO) {
                PCVZ = 0.8126 * Math.pow(PCJ, 1.0134)
              } else if (animal.sexo === MACHO_CASTRADO) {
                PCVZ = 0.6240 * Math.pow(PCJ, 1.0608)
              }
            } else if (animal.raca === CRUZADO_CORTE || animal.raca === CRUZADO_LEITE) {
              if (animal.sexo === MACHO) {
                PCVZ = 0.7248 * Math.pow(PCJ, 1.0314)
              } else if (animal.sexo === MACHO_CASTRADO) {
                PCVZ = 0.6586 * Math.pow(PCJ, 1.0499)
              }
            }
          }
        }
      } else if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        if (animal.estado_fisiologico === LACTANTE || animal.estado_fisiologico === GESTANTE_LACTANTE) {
          PCVZ = 0.8507 * Math.pow(PCJ, 1.0002)
        } else {
          PCVZ = 0.8424 * Math.pow(PCJ, 1.0122)
        }
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        PCVZ = 0.962 * PCJ
      }
      this.NDT.childs.PCVZ.minimo = PCVZmin
      this.NDT.childs.PCVZ.ideal = PCVZ
      this.NDT.childs.PCVZ.maximo = PCVZmax
    }

    calcPCVZeq () {
      const animal = this.animal
      var PCVZ = this.NDT.childs.PCVZ.ideal
      var PCVZeq = 0
      var PCVZeqmin = 0
      var PCVZeqmax = 0
      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        // -----FÊMEA-----
        if (animal.sexo === FEMEA) {
          if (animal.raca === ZEBUINO) {
            PCVZeq = (PCVZ / 402) * 517
          } else if (animal.raca === CRUZADO_CORTE) {
            PCVZeq = (PCVZ / 417) * 517
          } else if (animal.raca === CRUZADO_LEITE) {
            PCVZeq = (PCVZ / 493) * 517
          }
          // -----MACHO-----
        } else {
          if (animal.raca === ZEBUINO) {
            if (animal.sexo === MACHO) {
              PCVZeq = (PCVZ / 517) * 517
            } else if (animal.sexo === MACHO_CASTRADO) {
              PCVZeq = (PCVZ / 433) * 517
            }
          } else if (animal.raca === CRUZADO_CORTE) {
            if (animal.sexo === MACHO) {
              PCVZeq = (PCVZ / 560) * 517
            } else if (animal.sexo === MACHO_CASTRADO) {
              PCVZeq = (PCVZ / 482) * 517
            }
          } else if (animal.raca === CRUZADO_LEITE) {
            if (animal.sexo === MACHO) {
              PCVZeq = (PCVZ / 616) * 517
            } else if (animal.sexo === MACHO_CASTRADO) {
              PCVZeq = (PCVZ / 532) * 517
            }
          }
        }
      }
      this.NDT.childs.PCVZeq.minimo = PCVZeqmin
      this.NDT.childs.PCVZeq.ideal = PCVZeq
      this.NDT.childs.PCVZeq.maximo = PCVZeqmax
    }

    calcGPCVZ () {
      const animal = this.animal
      const GMD = animal.ganho_medio_diario
      var GPCVZ = 0
      var GPCVZmin = 0
      var GPCVZmax = 0

      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        GPCVZ = 0.963 * Math.pow(GMD, 1.0151)

        // GPCVZ = 0.958 * GMD
      } else if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        GPCVZ = 0.963 * Math.pow(GMD, 1.0151)
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        GPCVZ = 0.958 * GMD
      }
      this.NDT.childs.GPCVZ.minimo = GPCVZmin
      this.NDT.childs.GPCVZ.ideal = GPCVZ
      this.NDT.childs.GPCVZ.maximo = GPCVZmax
    }

    calcEL () {
      const animal = this.animal
      const PLe = animal.producao_de_leite
      const ECC = animal.escore_corporal
      const BEZ = animal.peso_bezerro_nascimento
      const TG = animal.dias_gestacao
      const PCVZ = this.NDT.childs.PCVZ.ideal
      const PCVZeq = this.NDT.childs.PCVZeq.ideal
      const GPCVZ = this.NDT.childs.GPCVZ.ideal
      var ELmin = 0.0
      var ELmax = 0.05
      var EL = 0
      var ELm = 0
      var ELmmin = 0.00
      var ELmmax = 0.05
      var ELg = 0
      var ELgmin = 0
      var ELgmax = 0.05
      var ELl = 0
      var ELlmin = 0
      var ELlmax = 0.05
      var PLeite = PLe
      var PLeitemin = 0
      var PLeitemax = 0
      var PLCG = PLe - (PLe * 0.02)
      var PLCGmin = 0
      var PLCGmax = 0

      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        ELm = 0.075 * Math.pow(PCVZ, 0.75)
        if (animal.sexo === FEMEA) {
          if (animal.regime === CONFINAMENTO) {
            ELg = 0.061 * Math.pow(PCVZeq, 0.75) * Math.pow(GPCVZ, 1.035)
          } else if (animal.regime === PASTO) {
            ELg = 0.052 * Math.pow(PCVZeq, 0.75) * Math.pow(GPCVZ, 1.062)
          }
        } else {
          if (animal.regime === CONFINAMENTO) {
            ELg = 0.061 * Math.pow(PCVZeq, 0.75) * Math.pow(GPCVZ, 1.035)
          } else if (animal.regime === PASTO) {
            ELg = 0.052 * Math.pow(PCVZeq, 0.75) * Math.pow(GPCVZ, 1.062)
          }
        }
      } else if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        if (animal.estado_fisiologico === LACTANTE) {
          ELm = (97.8 * Math.pow(PCVZ, 0.75)) / 1000
          ELg = 1.0076 * Math.pow(PCVZ, 0.2389) * GPCVZ
          ELl = 0.82 * PLe
        } else if (animal.estado_fisiologico === GESTANTE) {
          ELm = (85.9 * Math.pow(PCVZ, 0.75)) / 1000
          ELg = 3.82 * Math.pow(GPCVZ, 1.07) * Math.pow(ECC, 0.35)
          var ELgest = (((BEZ * 0.000000793 * Math.pow(TG, 3.017)) / 1000) / 0.12) * 0.66
          ELm = ELm + ELgest
        } else if (animal.estado_fisiologico === GESTANTE_LACTANTE) {
          ELm = (97.8 * Math.pow(PCVZ, 0.75)) / 1000
          ELg = 1.0076 * Math.pow(PCVZ, 0.2389) * GPCVZ
          ELgest = (((BEZ * 0.000000793 * Math.pow(TG, 3.017)) / 1000) / 0.12) * 0.66
          ELl = 0.82 * PLe
          ELm = ELm + ELgest
        } else {
          ELm = (85.9 * Math.pow(PCVZ, 0.75)) / 1000
          ELg = 3.82 * Math.pow(GPCVZ, 1.07) * Math.pow(ECC, 0.35)
        }
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        ELm = (70.3 * Math.pow(PCVZ, 0.75)) / 1000
        ELg = 0.0932 * Math.pow(PCVZ, 0.75) * Math.pow(GPCVZ, 0.9157)
      }

      EL = ELm + ELg + ELl

      this.EL.minimo = (EL * (1 - ELmin))
      this.EL.ideal = EL
      this.EL.maximo = (EL * (1 + ELmax))

      this.EL.childs.ELm.minimo = (ELm * (1 - ELmmin))
      this.EL.childs.ELm.ideal = ELm
      this.EL.childs.ELm.maximo = (ELm * (1 + ELmmax))

      this.EL.childs.ELg.minimo = (ELg * (1 - ELgmin))
      this.EL.childs.ELg.ideal = ELg
      this.EL.childs.ELg.maximo = (ELg * (1 + ELgmax))

      this.EL.childs.ELl.minimo = (ELl * (1 - ELlmin))
      this.EL.childs.ELl.ideal = ELl
      this.EL.childs.ELl.maximo = (ELl * (1 + ELlmax))

      this.EL.childs.PL.minimo = PLeitemin
      this.EL.childs.PL.ideal = PLeite
      this.EL.childs.PL.maximo = PLeitemax

      this.EL.childs.PLCG.minimo = PLCGmin
      this.EL.childs.PLCG.ideal = PLCG
      this.EL.childs.PLCG.maximo = PLCGmax
    }

    calcERp () {
      const animal = this.animal
      const GPCVZ = this.NDT.childs.GPCVZ.ideal
      const ELg = this.EL.childs.ELg.ideal
      var ERp = 0
      var ERpmin = 0
      var ERpmax = 0
      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        ERp = (1.14 * Math.pow(ELg / GPCVZ, -1.137))
      }
      this.EL.childs.ERP.minimo = (ERp * (1 - ERpmin))
      this.EL.childs.ERP.ideal = ERp
      this.EL.childs.ERP.maximo = (ERp * (1 + ERpmax))
    }

    calcKG () {
      const animal = this.animal
      const ERp = this.EL.childs.ERP.ideal
      const PLe = animal.producao_de_leite
      const PV = this.PV
      const GMD = animal.ganho_medio_diario

      var kg = 0
      var kgmin = 0
      var kgmax = 0
      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        kg = 0.327 / (0.539 + ERp)
      } else if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        if (animal.estado_fisiologico === LACTANTE || animal.estado_fisiologico === GESTANTE_LACTANTE) {
          kg = 0.44
        } else {
          kg = 0.53
        }
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        var CS = 0.353 - 0.532 * 0.1392 * PLe + 0.01065 * PV + 0.3497 * GMD
        var CL = 0.1392 * PLe
        kg = (CL * 0.69) / (CS + CL) + (CS * 0.57) / (CS + CL)
      }

      this.EL.childs.kg.ideal = kgmin
      this.EL.childs.kg.ideal = kg
      this.EL.childs.kg.maximo = kgmax
    }

    calcKM () {
      const animal = this.animal
      const kg = this.EL.childs.kg.ideal
      const PCVZ = this.NDT.childs.PCVZ.ideal
      const GPCVZ = this.NDT.childs.GPCVZ.ideal
      const ELg = this.EL.childs.ELg.ideal
      const ELm = this.EL.childs.ELm.ideal
      var EMg = 0
      var km = 0
      var kmmin = 0
      var kmmax = 0
      var EMm = 0
      var Kg = 0
      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        if (animal.regime === PASTO) {
          km = (0.513 + 0.173 * kg + 0.1 * GPCVZ) * 0.92
        } else if (animal.raca === ZEBUINO) {
          km = 0.513 + 0.173 * kg + 0.1 * GPCVZ
        } else if (animal.raca === CRUZADO_CORTE) {
          km = 0.513 + 0.173 * kg + 0.073 * GPCVZ
        } else if (animal.raca === CRUZADO_LEITE) {
          km = 0.513 + 0.173 * kg + 0.01 * GPCVZ
        }
      } else if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        if (animal.estado_fisiologico === GESTANTE_LACTANTE) {
          EMm = (135.0 * Math.pow(PCVZ, 0.75)) / 1000
          km = ((97.8 * Math.pow(PCVZ, 0.75)) / 1000) / EMm
        } if (animal.estado_fisiologico === GESTANTE) {
          km = 85.9 / 130
        } else {
          EMm = (135.0 * Math.pow(PCVZ, 0.75)) / 1000
          km = ELm / EMm
        }
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        EMm = 118.6 * Math.pow(PCVZ, 0.75) / 1000
        EMg = ELg / Kg
        km = ELm / EMm
      }
      this.EL.childs.km.minimo = kmmin
      this.EL.childs.km.ideal = km
      this.EL.childs.km.maximo = kmmax
      this.EM.childs.EMg.ideal = EMg
    }

    calcEM () {
      const animal = this.animal
      const kg = this.EL.childs.kg.ideal
      const PLe = animal.producao_de_leite
      const BEZ = animal.peso_bezerro_nascimento
      const TG = animal.dias_gestacao
      const PCVZ = this.NDT.childs.PCVZ.ideal
      const ELg = this.EL.childs.ELg.ideal
      const ELm = this.EL.childs.ELm.ideal
      var km = this.EL.childs.km.ideal
      var EMmmin = 0
      var EMmmax = 0.05
      var EMg = this.EM.childs.EMg.ideal
      var EMgmin = 0
      var EMgmax = 0.05
      var EMmin = 0.00
      var EMmax = 0.05
      var EM = 0
      var EMm = 0
      var ELl = 0
      var EMl = 0
      var EMlmin = 0
      var EMlmax = 0.05

      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        EMm = ELm / km
        EMg = ELg / kg
      } else if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        if (animal.estado_fisiologico === LACTANTE) {
          EMm = (135.0 * Math.pow(PCVZ, 0.75)) / 1000
          EMg = ELg / kg
          // EMl = 0.72 * PLe / km
          ELl = 0.82 * PLe
          EMl = ELl / 0.72
        } else if (animal.estado_fisiologico === GESTANTE) {
          EMm = (135.0 * Math.pow(PCVZ, 0.75)) / 1000
          EMg = ELg / 0.53
          var EMgest = ((BEZ * 0.000000793 * Math.pow(TG, 3.017)) / 1000) / 0.12
          EMm = EMm + EMgest
        } else if (animal.estado_fisiologico === GESTANTE_LACTANTE) {
          EMm = (135.0 * Math.pow(PCVZ, 0.75)) / 1000
          EMg = ELg / kg
          EMgest = ((BEZ * 0.000000793 * Math.pow(TG, 3.017)) / 1000) / 0.12
          km = ((97.8 * Math.pow(PCVZ, 0.75)) / 1000) / EMm
          //EMl = 0.72 * PLe / km
          ELl = 0.82 * PLe
          EMl = ELl / 0.72
          EMm = EMm + EMgest
        } else {
          km = 0.72
          EMm = ELm / km * 1.085
          EMg = ELg / kg
        }
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        EMm = 118.6 * Math.pow(PCVZ, 0.75) / 1000
        EMg = ELg / kg
      }
      EM = EMm + EMg + EMl
      this.EM.minimo = (EM * (1 - EMmin))
      this.EM.ideal = EM
      this.EM.maximo = (EM * (1 + EMmax))

      this.EM.childs.EMm.minimo = (EMm * (1 - EMmmin))
      this.EM.childs.EMm.ideal = EMm
      this.EM.childs.EMm.maximo = (EMm * (1 + EMmmax))

      this.EM.childs.EMg.minimo = (EMg * (1 - EMgmin))
      this.EM.childs.EMg.ideal = EMg
      this.EM.childs.EMg.maximo = (EMg * (1 + EMgmax))

      this.EM.childs.EMl.minimo = (EMl * (1 - EMlmin))
      this.EM.childs.EMl.ideal = EMl
      this.EM.childs.EMl.maximo = (EMl * (1 + EMlmax))
    }

    calcED () {
      const animal = this.animal
      const EM = this.EM.ideal
      const CMS = this.CMS.ideal
      var ED = 0
      var EDmin = 0
      var EDmax = 0
      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        ED = ((EM / CMS) + 0.3032) * (CMS / 0.9455)
      } else if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        if (animal.estado_fisiologico === GESTANTE) {
          ED = ((EM / CMS) + 0.2227) * (CMS / 0.9147)
        } else if (animal.estado_fisiologico === GESTANTE_LACTANTE) {
          ED = ((EM / CMS) + 0.2227) * (CMS / 0.9147)
        } else {
          ED = ((EM / CMS) + 0.3032) * (CMS / 0.9455)
        }
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        ED = (EM / 0.96)
      }
      this.EM.childs.ED.minimo = EDmin
      this.EM.childs.ED.ideal = ED
      this.EM.childs.ED.maximo = EDmax
    }

    calcNDT () {
      const ED = this.EM.childs.ED.ideal
      var NDTmin = 0
      var NDTmax = 0.05
      var NDT = ED / 4.4
      this.NDT.minimo = (NDT * (1 - NDTmin))
      this.NDT.ideal = (NDT)
      this.NDT.maximo = (NDT * (1 + NDTmax))
    }

    calcEnergias () {
      this.calcCMS()
      this.calcEE()
      this.calcCNF()
      this.calcFDN()
      this.calcPCJ()
      this.calcPCVZ()
      this.calcPCVZeq()
      this.calcGPCVZ()
      this.calcEL()
      this.calcERp()
      this.calcKG()
      this.calcKM()
      this.calcEM()
      this.calcED()
      this.calcNDT()
    }

    calcK () {
      const animal = this.animal
      const PCVZ = this.NDT.childs.PCVZ.ideal
      let PCVZeq = this.NDT.childs.PCVZeq.ideal
      const PV = this.PV
      var k = 0
      var kmin = 0
      var kmax = 0

      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        if (PV > 340) {
          k = 47.4
        } else {
          k = 84.665 - (0.1179 * PCVZeq)
        }
      } else if (animal.tipo === VACA || animal.tipo === BEZERRO) {
        // -------------VACA------------------------------------------------------
        // -------------BEZERRO------------------------------------------------------
        if (PV > 300) {
          k = 47.4
        } else {
          PCVZeq = PCVZ
          k = 84.665 - (0.1179 * PCVZeq)
        }
      }
      this.PB.childs.k.minimo = kmin
      this.PB.childs.k.ideal = k
      this.PB.childs.k.maximo = kmax
    }

    calcPL () {
      const animal = this.animal
      const BEZ = animal.peso_bezerro_nascimento
      const TG = animal.dias_gestacao
      const PCVZ = this.NDT.childs.PCVZ.ideal
      const PCVZeq = this.NDT.childs.PCVZeq.ideal
      const GPCVZ = this.NDT.childs.GPCVZ.ideal
      const ELg = this.EL.childs.ELg.ideal
      var PLg = 0
      var PLgmin = 0
      var PLgmax = 0.10
      var PL = 0
      var PLmin = 0
      var PLmax = 0.10

      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        // PLg = (176.01 * GPCVZ) - (6.239 * ELg)
        PLg = (176.01 * GPCVZ) - ((0.381 * Math.pow(PCVZeq, 0.75)) * Math.pow(GPCVZ, 1.035))
      } else if (animal.tipo === VACA) {
        // -------------VACA-----------------------------------------------------
        if (animal.estado_fisiologico === LACTANTE) {
          PLg = 376.4 * Math.pow(PCVZ, -0.1839) * GPCVZ
        } else if (animal.estado_fisiologico === GESTANTE) {
          PLg = 307 * GPCVZ - 34 * ELg
          var PLgest = (BEZ * 0.0000001773 * Math.pow(TG, 2.945))
          PLg = PLg + PLgest
        } else if (animal.estado_fisiologico === GESTANTE_LACTANTE) {
          PLg = 376.4 * Math.pow(PCVZ, -0.1839) * GPCVZ
          PLgest = (BEZ * 0.0000001773 * Math.pow(TG, 2.945))
          PLg = PLg + PLgest
        } else {
          PLg = 307 * GPCVZ - 34 * ELg
        }
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        PLg = (139.7 * Math.pow(PCVZ, 0.0351) * GPCVZ)
      }
      PL = PLg
      this.PB.childs.PLg.minimo = (PLg * (1 - PLgmin))
      this.PB.childs.PLg.ideal = PLg
      this.PB.childs.PLg.maximo = (PLg * (1 + PLgmax))

      this.PB.childs.PL.minimo = (PL * (1 - PLmin))
      this.PB.childs.PL.ideal = PL
      this.PB.childs.PL.maximo = (PL * (1 + PLmax))
    }

    calcPM () {
      const animal = this.animal
      const PCJ = this.NDT.childs.PCJ.ideal
      const PLg = this.PB.childs.PLg.ideal
      const PLe = animal.producao_de_leite
      const BEZ = animal.peso_bezerro_nascimento
      const TG = animal.dias_gestacao
      var k = this.PB.childs.k.ideal
      var PM = 0
      var PMmin = 0
      var PMmax = 0.1
      var PMm = 0
      var PMmmin = 0
      var PMmmax = 0.1
      var PMg = 0
      var PMgmin = 0
      var PMgmax = 0.1
      var PMl = 0
      var PMlmin = 0
      var PMlmax = 0.1
      var Pmet = 50.5

      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO--------------------------------
        if (animal.regime === CONFINAMENTO) {
          PMm = 3.6 * Math.pow(PCJ, 0.75)
          PMg = PLg / (k / 100)
        } else {
          PMm = 3.9 * Math.pow(PCJ, 0.75)
          PMg = PLg / (k / 100)
        }
      } else if (animal.tipo === VACA) {
        // -------------VACA-----------------------------------------------------
        if (animal.estado_fisiologico === LACTANTE) {
          PMm = 3.9 * Math.pow(PCJ, 0.75)
          PMg = PLg / (k / 100)
          PMl = Pmet * PLe
        } else if (animal.estado_fisiologico === GESTANTE) {
          PMm = 3.9 * Math.pow(PCJ, 0.75)
          PMg = PLg / 0.474
          var PMgest = (BEZ * 0.0000001773 * Math.pow(TG, 2.945)) / 0.474
          PMg = PMg + PMgest
        } else if (animal.estado_fisiologico === GESTANTE_LACTANTE) {
          PMm = 3.9 * Math.pow(PCJ, 0.75)
          PMg = PLg / (k / 100)
          PMl = Pmet * PLe
          PMgest = (BEZ * 0.0000001773 * Math.pow(TG, 2.945)) / 0.474
          PMg = PMg + PMgest
        } else {
          k = 47.4
          PMm = 3.9 * Math.pow(PCJ, 0.75)
          PMg = PLg / (k / 100)
        }
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        PMm = 3.9 * Math.pow(PCJ, 0.75)
        PMg = PLg / (k / 100)
      }

      PM = PMm + PMg + PMl

      this.PM.minimo = (PM * (1 - PMmin))
      this.PM.ideal = (PM)
      this.PM.maximo = (PM * (1 + PMmax))

      this.PM.childs.PMm.minimo = (PMm * (1 - PMmmin))
      this.PM.childs.PMm.ideal = PMm
      this.PM.childs.PMm.maximo = (PMm * (1 + PMmmax))

      this.PM.childs.PMg.minimo = (PMg * (1 - PMgmin))
      this.PM.childs.PMg.ideal = PMg
      this.PM.childs.PMg.maximo = (PMg * (1 + PMgmax))

      this.PM.childs.PMl.minimo = (PMl * (1 - PMlmin))
      this.PM.childs.PMl.ideal = PMl
      this.PM.childs.PMl.maximo = (PMl * (1 + PMlmax))
    }

    calcPBMic () {
      const animal = this.animal
      const NDT = this.NDT.ideal
      const PM = this.PM.ideal
      const PCJ = this.NDT.childs.PCJ.ideal
      const PLe = animal.producao_de_leite
      var PBmic = 0
      var PBmicmin = 0
      var PBmicmax = 0
      var aux = 0
      var pb = 0
      var aux1 = 0
      var aux2 = 0
      var apb = 0
      const CPBLeite = PLe * 0.0356
      const CNDTLeite = PLe * 0.18
      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        apb = (120 * (NDT + (PM - 120 * NDT) * 0.64) / 0.8)
        aux = -53.07 + 304.9 * (apb / 1000) + 90.8 * NDT - 3.13 * Math.pow(NDT, 2)
        aux2 = apb + 2
        for (let i = 0; Math.abs(apb - aux2) * 10 > 1 && i < 100; i++) {
          aux2 = apb
          aux = -53.07 + 304.9 * (apb / 1000) + 90.8 * NDT - 3.13 * Math.pow(NDT, 2)
          apb = (aux + (PM - (aux * 0.64)) / 0.8)
        }
      } else if (animal.tipo === VACA) {
        aux = 120 * (NDT)
        pb = (aux + (PM - (aux * 0.64)) / 0.8)
        aux1 = pb + 2
        for (let i = 0; Math.abs(pb - aux1) * 10 > 1 && i < 100; i++) {
          aux1 = pb
          aux = -53.07 + 304.9 * (pb / 1000) + 90.8 * NDT - 3.13 * Math.pow(NDT, 2)
          pb = (aux + (PM - (aux * 0.64)) / 0.8)
        }
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        if (PCJ < 150) {
          aux = 120 * (NDT - CNDTLeite)
        } else {
          aux = 120 * (NDT - CNDTLeite)
          aux1 = pb + 2
          pb = aux + (PM - (aux * 0.64)) / 0.8
          for (let i = 0; Math.abs(pb - aux1) * 10 > 1 && i < 100; i++) {
            aux1 = pb
            aux = -53.07 + 304.9 * ((pb / 1000) - CPBLeite) + 90.8 * (NDT - CNDTLeite) - 3.13 * Math.pow(NDT - CNDTLeite, 2)
            pb = (aux + (PM - (aux * 0.64)) / 0.8)
          }
        }
      }
      if (aux < 0) { aux = 0 } // se o consumo de NDT do leite o PBmic é zero.
      PBmic = aux
      this.PM.childs.PBmic.minimo = PBmicmin
      this.PM.childs.PBmic.ideal = PBmic
      this.PM.childs.PBmic.maximo = PBmicmax
    }

    calcPDR () {
      const animal = this.animal
      var PDRmin = 0
      var PDRmax = 0.1
      var PDR = this.PM.childs.PBmic.ideal
      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        PDRmax = 0.1 * 1.5
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        PDRmax = 0.1 * 40
      }
      this.PDR.minimo = (PDR * (1 - PDRmin))
      this.PDR.ideal = (PDR)
      this.PDR.maximo = (PDR * (1 + PDRmax))
    }

    calcPNDR () {
      const animal = this.animal
      const PMm = this.PM.childs.PMm.ideal
      const PMg = this.PM.childs.PMg.ideal
      var PNDRmin = 0
      var PNDRmax = 0.1
      var PBmic = this.PM.childs.PBmic.ideal
      var PM = this.PM.ideal
      var PNDR = (PM - (PBmic * 0.64)) / 0.8
      if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        PNDRmax = 0.1 * 5
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        var PMt = PMm + PMg
        PNDR = (PMt - (PBmic * 0.64)) / 0.8
        PNDRmax = 0.1 * 2
      }
      this.PNDR.minimo = (PNDR * (1 - PNDRmin))
      this.PNDR.ideal = (PNDR)
      this.PNDR.maximo = (PNDR * (1 + PNDRmax))
    }

    calcPB () {
      var PBmin = 0
      var PBmax = 0.1
      const animal = this.animal
      const PDR = this.PDR.ideal
      const PNDR = this.PNDR.ideal
      var PB = PDR + PNDR
      if (animal.tipo === VACA) {
        PBmax = 0.1 * 3
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        PBmax = 0.1 * 5
      }
      this.PB.minimo = (PB * (1 - PBmin))
      this.PB.ideal = (PB)
      this.PB.maximo = (PB * (1 + PBmax))
    }

    calcProteinas () {
      this.calcK()
      this.calcPL()
      this.calcPM()
      this.calcPBMic()
      this.calcPDR()
      this.calcPNDR()
      this.calcPB()
    }
    calcMinerais () {
      const animal = this.animal
      const PLe = animal.producao_de_leite
      const CMS = this.CMS.ideal
      const PCVZ = this.NDT.childs.PCVZ.ideal
      const GPCVZ = this.NDT.childs.GPCVZ.ideal
      const PV = this.PV

      // --------------------------------------------------------------------------------
      // -----------------------------------Cálculo Ca ----------------------------------
      // --------------------------------------------------------------------------------

      var Camin = 0
      var Camax = 1.0
      var Cam = 0
      var Cammin = 0
      var Cammax = 1.0
      var Cag = 0
      var Cagmin = 0
      var Cagmax = 1.0
      var Cal = 0
      var Calmin = 0
      var Calmax = 1.0

      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        if (animal.raca === ZEBUINO) {
          if (PCVZ <= 462) {
            Cam = ((11.7 * PV) / 1000) / 0.568
            Cag = (GPCVZ * (147 * Math.pow(PCVZ, -0.5))) / 0.568
          } else if (PCVZ > 462) {
            Cam = ((11.7 * PV) / 1000) / 0.568
            Cag = 0
          }
        } else {
          if (PCVZ <= 453) {
            Cam = ((11.7 * PV) / 1000) / 0.568
            Cag = (GPCVZ * (66 * Math.pow(PCVZ, -0.32))) / 0.568
          } else if (PCVZ > 453) {
            Cam = ((11.7 * PV) / 1000) / 0.568
            Cag = 0
          }
        }
      } else if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        Cam = ((11.7 * PV) / 1000) / 0.568
        Cag = (147 * Math.pow(PCVZ, -0.5) * GPCVZ) / 0.568
        if (animal.estado_fisiologico === GESTANTE) {
          if (PCVZ < 462) {
            Cag = (147 * Math.pow(PCVZ, -0.5) * GPCVZ) / 0.568
            Cam = Cam * 1.2
          } else {
            Cam = Cam * 1.2
          }
        } else if (animal.estado_fisiologico === GESTANTE_LACTANTE) {
          Cam = Cam * 1.2
          Cal = (1.1 * PLe) / 0.568
        } else if (animal.estado_fisiologico === LACTANTE) {
          Cal = (1.1 * PLe) / 0.568
          Cag = (147 * Math.pow(PCVZ, -0.5) * GPCVZ) / 0.568
        }
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        Cam = ((11.7 * PV) / 1000) / 0.568
        Cag = (54.8 * Math.pow(PCVZ, -0.3981) * GPCVZ) / 0.568
      }

      var Ca = Cam + Cag + Cal

      this.Ca.minimo = (Ca * (1 - Camin))
      this.Ca.ideal = (Ca)
      this.Ca.maximo = (Ca * (1 + Camax))

      this.Ca.childs.Cam.minimo = (Cam * (1 - Cammin))
      this.Ca.childs.Cam.ideal = Cam
      this.Ca.childs.Cam.maximo = (Cam * (1 + Cammax))

      this.Ca.childs.Cag.minimo = (Cag * (1 - Cagmin))
      this.Ca.childs.Cag.ideal = Cag
      this.Ca.childs.Cag.maximo = (Cag * (1 + Cagmax))

      this.Ca.childs.Cal.minimo = (Cal * (1 - Calmin))
      this.Ca.childs.Cal.ideal = Cal
      this.Ca.childs.Cal.maximo = (Cal * (1 + Calmax))

      // --------------------------------------------------------------------------------
      // ----------------------------------Cálculo P ------------------------------------
      // --------------------------------------------------------------------------------

      var Pmin = 0
      var Pmax = 1.0
      var Pm = 0
      var Pmmin = 0
      var Pmmax = 1.0
      var Pg = 0
      var Pgmin = 0
      var Pgmax = 1.0
      var Pl = 0
      var Plmin = 0
      var Plmax = 1.0

      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        if (animal.raca === ZEBUINO) {
          if (PCVZ <= 445) {
            Pm = ((13.5 * PV) / 1000) / 0.678
            Pg = (GPCVZ * (38.6 * Math.pow(PCVZ, -0.36))) / 0.678
          } else if (PCVZ > 445) {
            Pm = ((13.5 * PV) / 1000) / 0.678
            Pg = 0.0
          }
        } else {
          if (PCVZ <= 479) {
            Pm = ((13.5 * PV) / 1000) / 0.678
            Pg = (GPCVZ * (25.4 * Math.pow(PCVZ, -0.25))) / 0.678
          } else if (PCVZ > 479) {
            Pm = ((13.5 * PV) / 1000) / 0.678
            Pg = 0.0
          }
        }
      } else if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        Pm = ((13.5 * PV) / 1000) / 0.678
        Pg = (38.6 * Math.pow(PCVZ, -0.36) * GPCVZ) / 0.678
        if (animal.estado_fisiologico === GESTANTE) {
          Pm = Pm * 1.2
        } else if (animal.estado_fisiologico === GESTANTE_LACTANTE) {
          Pg = (54.4 * Math.pow(PCVZ, -0.4484) * GPCVZ) / 0.678
          Pm = Pm * 1.2
          Pl = (0.77 * PLe) / 0.678
        } else if (animal.estado_fisiologico === LACTANTE) {
          Pg = (54.4 * Math.pow(PCVZ, -0.4484) * GPCVZ) / 0.678
          Pl = (0.77 * PLe) / 0.678
        }
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        Pm = ((13.5 * PV) / 1000) / 0.678
        Pg = (8.6 * Math.pow(PCVZ, -0.0371) * GPCVZ) / 0.678
      }

      var P = Pm + Pg + Pl

      this.P.minimo = (P * (1 - Pmin))
      this.P.ideal = (P)
      this.P.maximo = (P * (1 + Pmax))

      this.P.childs.Pm.minimo = (Pm * (1 - Pmmin))
      this.P.childs.Pm.ideal = Pm
      this.P.childs.Pm.maximo = (Pm * (1 + Pmmax))

      this.P.childs.Pg.minimo = (Pg * (1 - Pgmin))
      this.P.childs.Pg.ideal = Pg
      this.P.childs.Pg.maximo = (Pg * (1 + Pgmax))

      this.P.childs.Pl.minimo = (Pl * (1 - Plmin))
      this.P.childs.Pl.ideal = Pl
      this.P.childs.Pl.maximo = (Pl * (1 + Plmax))

      // --------------------------------------------------------------------------------
      // ----------------------------------Cálculo Mg -----------------------------------
      // --------------------------------------------------------------------------------

      var Mgmin = 0
      var Mgmax = 2.0
      var Mgm = 0
      var Mgmmin = 0
      var Mgmmax = 2.0
      var Mgg = 0
      var Mggmin = 0
      var Mggmax = 2.0
      var Mgl = 0
      var Mglmin = 0
      var Mglmax = 2.0

      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        if (animal.raca === ZEBUINO) {
          Mgm = ((5.9 * PV) / 1000) / 0.355
          Mgg = (GPCVZ * (0.3466 * Math.pow(PCVZ, 0.0113))) / 0.355
        } else {
          Mgm = ((5.9 * PV) / 1000) / 0.355
          Mgg = (GPCVZ * (1.0597 * Math.pow(PCVZ, -0.2386))) / 0.355
        }
      } else if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        Mgm = ((5.9 * PV) / 1000) / 0.355
        if (animal.estado_fisiologico === LACTANTE) {
          Mgg = (1.4 * Math.pow(PCVZ, -0.3227) * GPCVZ) / 0.355
          Mgl = (0.07 * PLe) / 0.355
        } else if (animal.estado_fisiologico === GESTANTE) {
          Mgg = (0.3466 * Math.pow(PCVZ, -0.0113) * GPCVZ) / 0.355
          Mgm = Mgm * 1.2
        } else if (animal.estado_fisiologico === GESTANTE_LACTANTE) {
          Mgg = (1.4 * Math.pow(PCVZ, -0.3227) * GPCVZ) / 0.355
          Mgl = (0.07 * PLe) / 0.355
          Mgm = Mgm * 1.2
        } else {
          Mgg = (0.3466 * Math.pow(PCVZ, -0.0113) * GPCVZ) / 0.355
        }
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        Mgm = ((5.9 * PV) / 1000) / 0.355
        Mgg = (0.4 * Math.pow(PCVZ, -0.0173) * GPCVZ) / 0.355
      }

      var Mg = Mgm + Mgg + Mgl

      this.Mg.minimo = (Mg * (1 - Mgmin))
      this.Mg.ideal = (Mg)
      this.Mg.maximo = (Mg * (1 + Mgmax))

      this.Mg.childs.Mgm.minimo = (Mgm * (1 - Mgmmin))
      this.Mg.childs.Mgm.ideal = Mgm
      this.Mg.childs.Mgm.maximo = (Mgm * (1 + Mgmmax))

      this.Mg.childs.Mgg.minimo = (Mgg * (1 - Mggmin))
      this.Mg.childs.Mgg.ideal = Mgg
      this.Mg.childs.Mgg.maximo = (Mgg * (1 + Mggmax))

      this.Mg.childs.Mgl.minimo = (Mgl * (1 - Mglmin))
      this.Mg.childs.Mgl.ideal = Mgl
      this.Mg.childs.Mgl.maximo = (Mgl * (1 + Mglmax))

      // --------------------------------------------------------------------------------
      // ------------------------------------Cálculo K ----------------------------------
      // --------------------------------------------------------------------------------

      var Kmin = 0
      var Kmax = 2.0
      var Km = 0
      var Kmmin = 0.0
      var Kmmax = 2.0
      var Kg = 0
      var Kgmin = 0
      var Kgmax = 2.0
      var Kl = 0
      var Klmin = 0.0
      var Klmax = 2.0

      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        if (animal.raca === ZEBUINO) {
          Km = ((23.5 * PV) / 1000) / 0.484
          Kg = (GPCVZ * (0.9463 * Math.pow(PCVZ, 0.1216))) / 0.484
        } else {
          Km = ((23.5 * PV) / 1000) / 0.484
          Kg = (GPCVZ * (0.3418 * Math.pow(PCVZ, 0.32))) / 0.484
        }
      } if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        if (animal.estado_fisiologico === LACTANTE) {
          Km = ((23.5 * PV) / 1000) / 0.484
          Kg = (3.1 * Math.pow(PCVZ, -0.2142) * GPCVZ) / 0.484
          Kl = (0.7 * PLe) / 0.484
        } else if (animal.estado_fisiologico === GESTANTE) {
          Km = ((23.5 * PV) / 1000) / 0.484
          Kg = (0.9463 * Math.pow(PCVZ, -0.1216) * GPCVZ) / 0.484
          Km = Km * 1.2
        } else if (animal.estado_fisiologico === GESTANTE_LACTANTE) {
          Km = ((23.5 * PV) / 1000) / 0.484
          Kg = (3.1 * Math.pow(PCVZ, -0.2142) * GPCVZ) / 0.484
          Kl = (0.7 * PLe) / 0.484
          Km = Km * 1.2
        } else {
          Km = ((23.5 * PV) / 1000) / 0.484
          Kg = (0.9463 * Math.pow(PCVZ, -0.1216) * GPCVZ) / 0.484
        }
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        Km = ((23.5 * PV) / 1000) / 0.484
        Kg = (1.5 * Math.pow(PCVZ, -0.0636) * GPCVZ) / 0.484
      }

      var K = Km + Kg + Kl

      this.K.minimo = (K * (1 - Kmin))
      this.K.ideal = (K)
      this.K.maximo = (K * (1 + Kmax))

      this.K.childs.KM.minimo = (Km * (1 - Kmmin))
      this.K.childs.KM.ideal = Km
      this.K.childs.KM.maximo = (Km * (1 + Kmmax))

      this.K.childs.Kg.minimo = (Kg * (1 - Kgmin))
      this.K.childs.Kg.ideal = Kg
      this.K.childs.Kg.maximo = (Kg * (1 + Kgmax))

      this.K.childs.Kl.minimo = (Kl * (1 - Klmin))
      this.K.childs.Kl.ideal = Kl
      this.K.childs.Kl.maximo = (Kl * (1 + Klmax))
      // --------------------------------------------------------------------------------
      // ----------------------------------Cálculo Na -----------------------------------
      // --------------------------------------------------------------------------------

      var Namin = 0
      var Namax = 5.0
      var Nam = 0
      var Nammin = 0
      var Nammax = 5.0
      var Nag = 0
      var Nagmin = 0
      var Nagmax = 5.0
      var Nal = 0
      var Nalmin = 0
      var Nalmax = 5.0

      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        if (animal.raca === ZEBUINO) {
          Nam = ((6.3 * PV) / 1000) / 0.371
          Nag = (GPCVZ * (5.594 * Math.pow(PCVZ, -0.2998))) / 0.371
        } else {
          Nam = ((6.3 * PV) / 1000) / 0.371
          Nag = (GPCVZ * (1.977 * Math.pow(PCVZ, -0.058))) / 0.371
        }
      } else if (animal.tipo === VACA) {
        Nam = ((6.3 * PV) / 1000) / 0.371
        if (animal.estado_fisiologico === LACTANTE) {
          Nag = (1.4 * Math.pow(PCVZ, -0.0575) * GPCVZ) / 0.371
          Nal = (0.18 * PLe) / 0.371
        } else if (animal.estado_fisiologico === GESTANTE) {
          Nag = (5.594 * Math.pow(PCVZ, -0.2998) * GPCVZ) / 0.371
          Nam = Nam * 1.2
        } else if (animal.estado_fisiologico === GESTANTE_LACTANTE) {
          Nag = (1.4 * Math.pow(PCVZ, -0.0575) * GPCVZ) / 0.371
          Nal = (0.18 * PLe) / 0.371
          Nam = Nam * 1.2
        } else {
          Nag = (5.594 * Math.pow(PCVZ, -0.2998) * GPCVZ) / 0.371
        }
      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        Nam = ((6.3 * PV) / 1000) / 0.371
        Nag = (1.2 * Math.pow(PCVZ, -0.0209) * GPCVZ) / 0.371
      }

      var Na = Nam + Nag + Nal

      this.Na.minimo = (Na * (1 - Namin))
      this.Na.ideal = (Na)
      this.Na.maximo = (Na * (1 + Namax))

      this.Na.childs.Nam.minimo = (Nam * (1 - Nammin))
      this.Na.childs.Nam.ideal = Nam
      this.Na.childs.Nam.maximo = (Nam * (1 + Nammax))

      this.Na.childs.Nag.minimo = (Nag * (1 - Nagmin))
      this.Na.childs.Nag.ideal = Nag
      this.Na.childs.Nag.maximo = (Nag * (1 + Nagmax))

      this.Na.childs.Nal.minimo = (Nal * (1 - Nalmin))
      this.Na.childs.Nal.ideal = Nal
      this.Na.childs.Nal.maximo = (Nal * (1 + Nalmax))
      // --------------------------------------------------------------------------------
      // -----------------------------------Cálculo S -----------------------------------
      // --------------------------------------------------------------------------------

      var Smin = 0
      var Smax = 2.0
      var S = 0

      if (animal.tipo === CRESCIMENTO_TERMINACAO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        S = (GPCVZ * (0.03 * Math.pow(PCVZ, 0.8900)) + ((10.4 * PV) / 1000)) / 0.773
      } else if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        let S_Mantenca = (10.4 * PV) / 1000
        let S_Ganho = GPCVZ * (0.03 * Math.pow(PCVZ, 0.89))
        let S_Lactacao = 0.3 * PLe
        if ([LACTANTE, GESTANTE_LACTANTE].includes(animal.estado_fisiologico)) {
          S = (S_Mantenca + S_Ganho + S_Lactacao) / 0.773
        } else {
          S = (S_Mantenca + S_Ganho) / 0.773
        }
        
        /*
        if (animal.estado_fisiologico === LACTANTE) {
          S = (GPCVZ * 0.03 * Math.pow(PCVZ, 0.89) + ((10.4 * PV) / 1000) + (0.3 * PLe)) / 0.773
        } else if (animal.estado_fisiologico === GESTANTE) {
          S = (GPCVZ * 0.03 * Math.pow(PCVZ, 0.89) / 1.2 + ((10.4 * PV) / 1000)) * (1.2 / 0.773)
        } else if (animal.estado_fisiologico === GESTANTE_LACTANTE) {
          S = (GPCVZ * 0.03 * Math.pow(PCVZ, 0.89) / 1.2 + ((10.4 * PV) / 1000) + (0.3 * PLe) / 1.2) * (1.2 / 0.773)
        } else {
          S = (GPCVZ * 0.03 * Math.pow(PCVZ, 0.89) + ((10.4 * PV) / 1000)) / 0.773
        }
        */

      } else if (animal.tipo === BEZERRO) {
        // -------------BEZERRO------------------------------------------------------
        S = (GPCVZ * 0.03 * Math.pow(PCVZ, 0.89) + ((10.4 * PV) / 1000)) / 0.773
      }
      this.S.minimo = (S * (1 - Smin))
      this.S.ideal = (S)
      this.S.maximo = (S * (1 + Smax))

      // --------------------------------------------------------------------------------
      // ----------------------------------Cálculo Co ----------------------------------
      // --------------------------------------------------------------------------------

      var Comin = 0
      var Comax = 19.0
      var Co = 0

      if (animal.tipo === VACA) {
        if (animal.estado_fisiologico === LACTANTE) {
          Co = (GPCVZ * (0.045 * Math.pow(PCVZ, -0.23)) + (13.5 * PV / 1000) + 0.23 * PLe) / 0.868
        } else if (animal.estado_fisiologico === GESTANTE) {
          Co = (GPCVZ * (0.045 * Math.pow(PCVZ, -0.23))) / 0.868 + ((13.5 * PV / 1000) * 1.2) / 0.868
        } else if (animal.estado_fisiologico === GESTANTE_LACTANTE) {
          Co = (GPCVZ * (0.045 * Math.pow(PCVZ, -0.23))) / 0.868 + (1.2 * (13.5 * PV / 1000)) / 0.868 + (0.23 * PLe) / 0.868
        } else {
          Co = (GPCVZ * (0.045 * Math.pow(PCVZ, -0.23)) + (13.5 * PV / 1000)) / 0.868
        }
      } else {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        // -------------BEZERRO------------------------------------------------------
        Co = (GPCVZ * (0.045 * Math.pow(PCVZ, -0.23)) + (13.5 * PV / 1000)) / 0.868
      }

      this.Co.minimo = (Co * (1 - Comin))
      this.Co.ideal = (Co)
      this.Co.maximo = (Co * (1 + Comax))

      // --------------------------------------------------------------------------------
      // ----------------------------------Cálculo Cu ----------------------------------
      // --------------------------------------------------------------------------------

      var Cumin = 0
      var Cumax = 2.0
      var Cu = 0
      if (animal.tipo === CRESCIMENTO_TERMINACAO || animal.tipo === BEZERRO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        // -------------BEZERRO------------------------------------------------------
        Cu = (GPCVZ * (1.25 * Math.pow(PCVZ, 0.33)) + (95.6 * PV / 1000)) / 0.735
      } else if (animal.tipo === VACA) {
        if (animal.estado_fisiologico === LACTANTE) {
          // -------------VACA------------------------------------------------------
          Cu = (GPCVZ * (1.25 * Math.pow(PCVZ, 0.33)) + (95.6 * PV / 1000) + 1.99 * PLe) / 0.735
        } else if (animal.estado_fisiologico === GESTANTE) {
          Cu = (GPCVZ * (1.25 * Math.pow(PCVZ, 0.33))) / 0.735 + (1.2 * (95.6 * PV / 1000)) / 0.735
        } else if (animal.estado_fisiologico === GESTANTE_LACTANTE) {
          Cu = (GPCVZ * (1.25 * Math.pow(PCVZ, 0.33))) / 0.735 + (1.2 * (95.6 * PV / 1000)) / 0.735 + (1.99 * PLe) / 0.735
        } else {
          Cu = (GPCVZ * (1.25 * Math.pow(PCVZ, 0.33)) + (95.6 * PV / 1000)) / 0.735
        }
      }

      this.Cu.minimo = (Cu * (1 - Cumin))
      this.Cu.ideal = (Cu)
      this.Cu.maximo = (Cu * (1 + Cumax))

      // --------------------------------------------------------------------------------
      // ----------------------------------Cálculo I ----------------------------------
      // --------------------------------------------------------------------------------

      var Imin = 0
      var Imax = 19.0
      var I = 0.5 * CMS
      if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        if (animal.estado_fisiologico === GESTANTE || animal.estado_fisiologico === GESTANTE_LACTANTE) {
          I = 0.5 * CMS * 1.2
        }
      }
      this.I.minimo = (I * (1 - Imin))
      this.I.ideal = (I)
      this.I.maximo = (I * (1 + Imax))

      // --------------------------------------------------------------------------------
      // ----------------------------------Cálculo Mn ----------------------------------
      // --------------------------------------------------------------------------------

      var Mnmin = 0
      var Mnmax = 2.0
      var Mn = 0
      if (animal.tipo === CRESCIMENTO_TERMINACAO || animal.tipo === BEZERRO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        // -------------BEZERRO------------------------------------------------------
        Mn = (GPCVZ * (0.07 * Math.pow(PCVZ, 0.8000)) + (184.9 * PV / 1000)) / 0.439
      } else if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        if (animal.estado_fisiologico === GESTANTE) {
          Mn = (GPCVZ * (0.07 * Math.pow(PCVZ, 0.8000))) / 0.439 + (1.2 * (184.9 * PV / 1000)) / 0.439
        } else if (animal.estado_fisiologico === LACTANTE) {
          Mn = (GPCVZ * (0.07 * Math.pow(PCVZ, 0.8000)) + (184.9 * PV / 1000) + 1.41 * PLe) / 0.439
        } else if (animal.estado_fisiologico === GESTANTE_LACTANTE) {
          Mn = ((GPCVZ * (0.07 * Math.pow(PCVZ, 0.8000))) / 0.439) + ((1.2 * (184.9 * PV / 1000)) / 0.439) + ((1.41 * PLe) / 0.439)
        } else {
          Mn = (GPCVZ * (0.07 * Math.pow(PCVZ, 0.8000)) + (184.9 * PV / 1000)) / 0.439
        }
      }
      this.Mn.minimo = (Mn * (1 - Mnmin))
      this.Mn.ideal = (Mn)
      this.Mn.maximo = (Mn * (1 + Mnmax))

      // --------------------------------------------------------------------------------
      // ----------------------------------Cálculo Se ----------------------------------
      // --------------------------------------------------------------------------------

      var Semin = 0
      var Semax = 19.0
      var Se = 0

      if (animal.tipo === CRESCIMENTO_TERMINACAO || animal.tipo === BEZERRO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        // -------------BEZERRO------------------------------------------------------
        Se = (GPCVZ * (1.07 * Math.pow(PCVZ, -0.07)) + (3.72 * PV / 1000)) / 0.487
      } else if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        if (animal.estado_fisiologico === GESTANTE) {
          Se = (GPCVZ * (1.07 * Math.pow(PCVZ, -0.07))) / 0.487 + (3.72 * PV / 1000) * (1.2 / 0.487)
        } else if (animal.estado_fisiologico === GESTANTE_LACTANTE) {
          // Se = ((GPCVZ * (0.07 * Math.pow(PCVZ,0.8000))) / 0.439) + ((1.2 * (184.9 * PV / 1000)) / 0.439) + ((1.41 * PLe) / 0.439)
          Se = (GPCVZ * (1.07 * Math.pow(PCVZ, -0.07))) / 0.487 + (3.72 * PV / 1000) * (1.2 / 0.487)
        } else {
          Se = (GPCVZ * (1.07 * Math.pow(PCVZ, -0.07)) + (3.72 * PV / 1000)) / 0.487
        }
      }

      this.Se.minimo = (Se * (1 - Semin))
      this.Se.ideal = (Se)
      this.Se.maximo = (Se * (1 + Semax))

      // --------------------------------------------------------------------------------
      // ----------------------------------Cálculo Zn ----------------------------------
      // --------------------------------------------------------------------------------

      var Znmin = 0
      var Znmax = 2.0
      var Zn = 0
      if (animal.tipo === CRESCIMENTO_TERMINACAO || animal.tipo === BEZERRO) {
        // -------------CRESCIMENTO E TERMINAÇÃO---------------------------------
        // -------------BEZERRO------------------------------------------------------
        Zn = (GPCVZ * (1.16 * Math.pow(PCVZ, 0.8600)) + (334.4 * PV / 1000)) / 0.668
      } else if (animal.tipo === VACA) {
        // -------------VACA------------------------------------------------------
        if (animal.estado_fisiologico === LACTANTE) {
          Zn = (GPCVZ * (1.16 * Math.pow(PCVZ, 0.8600)) + (334.4 * PV / 1000) + (35.4 * PLe)) / 0.668
        } else if (animal.estado_fisiologico === GESTANTE) {
          Zn = (GPCVZ * (1.16 * Math.pow(PCVZ, 0.8600))) / 0.668 + (1.2 * (334.4 * PV / 1000)) / 0.668
        } else if (animal.estado_fisiologico === GESTANTE_LACTANTE) {
          Zn = (GPCVZ * (1.16 * Math.pow(PCVZ, 0.8600))) / 0.668 + (1.2 * (334.4 * PV / 1000)) / 0.668 + ((35.4 * PLe)) / 0.668
        } else {
          Zn = (GPCVZ * (1.16 * Math.pow(PCVZ, 0.8600)) + (334.4 * PV / 1000)) / 0.668
        }
      }

      this.Zn.minimo = (Zn * (1 - Znmin))
      this.Zn.ideal = (Zn)
      this.Zn.maximo = (Zn * (1 + Znmax))
    }

    getData (name = null) {
      if (name === null) {
        let data = Object.assign({}, this.__data)
        for (let d in data) {
          if (d === 'modified') continue
          data[d] = this[d]
        }
        return data
      }
      if (this.__data[name]) {
        return this.__data[name]
      }
      return null
    }
    registerNormalizer (fn) {
      this.fn = fn
    }
}
export default Exigencias
